export default __webpack_public_path__ + "static/Rectangle-313-37dd2d650f02ee8833f79dc27d0f02db.jpg";